/*
  ========================================================================
  THEME: Impact v7.0.1 merge target + Gro unified rebuild
  STORES: Gro Clinics AU (groclinics.com.au) + NZ (groclinics.co.nz)
  LAST UPDATED: 15/06/2026
  ========================================================================
  Rewrites restricted surgical terminology in visible page text.
  Add data-gro-terminology-ignore to preserve approved copy.
  ========================================================================
*/

(() => {
  const replacements = {
    surgery: 'procedure',
    surgeries: 'procedures',
    surgeon: 'doctor',
    surgeons: 'doctors'
  };
  const terminologyPattern = /\b(surgeries|surgery|surgeons|surgeon)\b/gi;
  const excludedTags = new Set([
    'CODE',
    'IFRAME',
    'KBD',
    'NOSCRIPT',
    'PRE',
    'SAMP',
    'SCRIPT',
    'STYLE',
    'TEMPLATE',
    'TEXTAREA'
  ]);

  const preserveCase = (matched, replacement) => {
    if (matched === matched.toUpperCase()) return replacement.toUpperCase();
    if (matched === matched.toLowerCase()) return replacement;

    if (matched[0] === matched[0].toUpperCase()) {
      return replacement[0].toUpperCase() + replacement.slice(1);
    }

    return replacement;
  };

  const isExcluded = (textNode) => {
    const parent = textNode.parentElement;

    return !parent ||
      excludedTags.has(parent.tagName) ||
      parent.closest('[data-gro-terminology-ignore], [contenteditable="true"], [contenteditable=""]');
  };

  const rewriteTextNode = (textNode) => {
    if (isExcluded(textNode) || !terminologyPattern.test(textNode.nodeValue)) return;

    terminologyPattern.lastIndex = 0;
    textNode.nodeValue = textNode.nodeValue.replace(terminologyPattern, (matched) => {
      return preserveCase(matched, replacements[matched.toLowerCase()]);
    });
  };

  const rewriteSubtree = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      rewriteTextNode(root);
      return;
    }

    if (
      root.nodeType !== Node.ELEMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE
    ) {
      return;
    }

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      (
        excludedTags.has(root.tagName) ||
        root.matches('[data-gro-terminology-ignore], [contenteditable="true"], [contenteditable=""]')
      )
    ) {
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      rewriteTextNode(textNode);
      textNode = walker.nextNode();
    }
  };

  const start = () => {
    rewriteSubtree(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          rewriteTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(rewriteSubtree);
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
